import React from 'react';
import Hero from '../../components/pages/Partnership/Hero/Hero';
import Form from '../../components/pages/Partnership/Form/Form';
import Consistency from '../../components/pages/Partnership/Consistency/Consistency';
import Support from '../../components/pages/Partnership/Support/Support';
import Explore from '../../components/pages/Partnership/Explore/Explore';

const Partnership = () => {
  return (
    <div>
      <Hero />
      <Form />
      <Consistency />
      <Support />
      <Explore />
    </div>
  );
};

export default Partnership;
